<ejs-dialog target=".dialogs" class="simple-dialog" [visible]='visible()'
  [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()'
  [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'" [height]="'60vh'"
  [zIndex]="999" [showCloseIcon]="true" (close)="close()">
  <ng-template #header>
    <div class="d-flex align-items-center justify-content-center">
      @if(isAdminSettings()) {
        <app-headline [title]="('HOMEICONSADMINEDIT' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
        <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('HOMEICONSADMINEDITHELP' | translate)" [width]="'300px'"
        [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
      } @else {
        <app-headline [title]="('HOMEICONSEDIT' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
        <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('HOMEICONSEDITHELP' | translate)" [width]="'300px'"
        [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
      }
    </div>
  </ng-template>
  <ng-template #content>
    <div class="d-flex flex-column h-100 p-3">
      @if (isAdminSettings()) {
        <div class="mb-1 small fw-semibold">
          <div class="d-flex align-items-center px-2 py-1">
            <div class="flex-grow-1 ps-5"></div>
            <div class="text-center px-2">
              <app-icon-badge [style]="'default'" [icon]="'desktop_windows'" [fontSize]="'fs-5'"
              [fontColor]="'text-primary'"></app-icon-badge>
            </div>
            <!-- TODO: when mobile app supports hiding icons just enable this template block -->
            <!-- <div class="text-center px-2">
              <app-icon-badge [style]="'default'" [icon]="'smartphone'" [fontSize]="'fs-5'"
              [fontColor]="'text-primary'"></app-icon-badge>
            </div> -->
          </div>
        </div>
      }
      <!-- Scrollable content-->
      <div class="homeReorderListBox custom-scrollbar overflow-y-auto">
        @for (icon of displayMenuIcons(); track icon; let i = $index) {
          <div class="card mb-2">
            <div class="d-flex align-items-stretch">
              <div class="d-flex align-items-center justify-content-center border-end">
                <div class="icon-size">
                  <app-icon-badge [style]="'homeIcons'" [icon]="icon.icon" [color]="icon.color"
                  [title]="icon.name | translate"></app-icon-badge>
                </div>
              </div>
              <div class="flex-grow-1 d-flex ps-2 align-items-center">
                <app-headline [type]="'h6'" [class]="'mb-0 text-muted fs-normal'"
                [title]="icon.name | translate"></app-headline>
              </div>
              <div class="d-flex align-items-center justify-content-center border-start px-2">
                @if (i !== 0) {
                  <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'"
                  [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'" (click)="moveIcon('up', icon.type)"></app-form-button>
                }
                @if (i !== iconsHome.length - 1) {
                  <app-form-button [style]="'btn'"
                    [cssClass]="'btn-link p-0 text-muted'" [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                  (click)="moveIcon('down', icon.type)"></app-form-button>
                }
              </div>
              @if (isAdminSettings()) {
                <div
                  class="checkbox-column d-flex align-items-center justify-content-center border-start px-2">
                  <ejs-checkbox [checked]="icon.is_active_desktop" class="pb-1 m-0" (checkedChange)="setWebValue(icon.type, $event)"></ejs-checkbox>
                </div>
                <!-- TODO: when mobile app supports hiding icons just enable this template block -->
                <!-- <div
                  class="checkbox-column d-flex align-items-center justify-content-center border-start px-2">
                  <ejs-checkbox [checked]="icon.is_active_mobile" class="pb-1 m-0" (checkedChange)="setMobileValue(icon.type, $event)"></ejs-checkbox>
                </div> -->
              }
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="d-flex align-items-center justify-content-center p-2">
      <app-form-button [text]="'SAVE' | translate" (click)="save()" [disabled]="!needsToBeSaved()"
      [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
    </div>
  </ng-template>
</ejs-dialog>